import PropTypes from 'prop-types';

import NotificationBase from './NotificationBase';

const Alert = ({ children, ...props }) => (
  <NotificationBase {...props}>{children}</NotificationBase>
);

Alert.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Alert;
